module.exports = __webpack_public_path__ + "img/social-whatsapp.2d4d1d7c.svg";